(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["return-form"] && !Shopify.designMode) return;
  try {
    class ReturnFormItems extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-items]');
      this.template = this.querySelector('[data-item-template]');
      this.addButton = this.querySelector('[data-add-item]');
      this.liveRegion = this.querySelector('[data-live-region]');
      this.max = Number(this.dataset.max) || 10;

      this.addButton.addEventListener('click', () => this.addItem());
      this.list.addEventListener('click', (event) => {
        const button = event.target.closest('[data-remove-item]');
        if (button) this.removeItem(button.closest('[data-item]'));
      });
    }

    get count() {
      return this.list.querySelectorAll('[data-item]').length;
    }

    addItem() {
      if (this.count >= this.max) return;

      const index = String(this.count + 1);
      const markup = this.template.innerHTML.replaceAll('__INDEX__', index);
      this.list.insertAdjacentHTML('beforeend', markup);

      const item = this.list.lastElementChild;
      item.querySelector('input, select')?.focus();
      this.announce(this.dataset.itemHeading.replace('__INDEX__', index));
      this.update();
    }

    removeItem(item) {
      if (!item) return;
      item.remove();
      this.renumber();
      this.addButton.focus();
      this.update();
    }

    /** Keeps field names and ids contiguous (Artikel 1..n) after a row is removed. */
    renumber() {
      this.list.querySelectorAll('[data-item]').forEach((item, position) => {
        const index = String(position + 1);
        item.querySelectorAll('[name], [id], [for]').forEach((element) => {
          for (const attribute of ['name', 'id', 'for']) {
            const value = element.getAttribute(attribute);
            if (value) element.setAttribute(attribute, value.replace(/\d+(?=\]?$)/, index));
          }
        });
        const legend = item.querySelector('[data-item-legend]');
        if (legend) legend.textContent = this.dataset.itemHeading.replace('__INDEX__', index);
      });
    }

    update() {
      this.addButton.hidden = this.count >= this.max;
    }

    announce(message) {
      this.liveRegion.textContent = message;
    }
  }

  if (!customElements.get('return-form-items')) {
    customElements.define('return-form-items', ReturnFormItems);
  }
  } catch(e) { console.error(e); }
})();

})();
